export default {
    pages: {
        221: [
            {
                id: '290522', // image_node
                attributes: [
                    {
                        name: 'zIndex',
                        value: 4 // The image must have a greater zIndex than the ce_button_nodes below it.
                    },
                ]
            },
            {
                id: '290523', // image_node
                attributes: [
                    {
                        name: 'zIndex',
                        value: 4 // The image must have a greater zIndex than the ce_button_nodes below it.
                    },
                ]
            },
        ],
    }
};



// WEBPACK FOOTER //
// ./src/js/transformers/MO.HOME.3.2.1.js